<template>
    <div>

        <div class="container-fluid blue-bg centers-list pb-0" v-if="!timetable && !profileMode">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="choose-course">
                            <select name="lang" v-model="langFilter">
                                <option :value="null">{{ $t('select_language') }}</option>
                                <option value="lang/en">{{ $t('english_lang') }}</option>
                                <option value="lang/es">{{ $t('spanish_lang') }}</option>
                                <option value="lang/de">{{ $t('german_lang') }}</option>
                                <option value="lang/fr">{{ $t('french_lang') }}</option>
                                <option value="lang/ch">{{ $t('chinese_lang') }}</option>
                                <option value="lang/ru">{{ $t('russian_lang') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="choose-age">
                            <select name="age" v-model="ageFilter">
                                <option :value="null">{{ $t('Age') }}</option>
                                <option value="min/1/max/6">{{ $t('preschooler') }}</option>
                                <option value="min/7/max/11">{{ $t('schoolboy_1_4_class') }}</option>
                                <option value="min/12/max/99">{{ $t('parent') }}</option>
                                <!-- <option value="min/12/max/17">12-17 лет</option> -->
                            </select>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="knopka">
                            <input :value="$t('find_lessons')" @click="filterTimetables()">
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div :class="['container-fluid pt-2 pb-1 pt-lg-3 pb-lg-1 timetable-container', { 'white-bg' : !timetable}]">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="row" v-if="error">
                            <div class="col-lg-12">
                                <base-alert type="danger" dismissible>{{error}}</base-alert>
                            </div>
                        </div>

                        <div class="row">
                            <div :class="['col-12 schedules-header', {'col-lg-12' : !timetable}, {'col-lg-7' : timetable}]">
                                <h1 v-if="timetable && timetable.about_link" class="mb-0">
                                    <a :href="timetable.about_link" target="_blank">{{ pageTitle }}</a>
                                </h1>
                                <h1 v-else v-html="pageHeaderHtml" class="mb-0"></h1>
                            </div>

                            <div v-if="!timetable && !loading && timetables.length === 0" class="col-12">
                                <div class="mt-5 mb-9  px-lg-9 px-5 no-timetables">
                                    <p>{{ $t('find_lessons_empty') }}<br>
                                        <router-link to="/entry">{{ $t('write') }}</router-link>
                                        {{ $t('_us_your_wishes_') }}
                                        <router-link to="/schedule">{{ $t('_from_available_at_this_moment') }}</router-link>
                                        .
                                    </p>
                                    <div class="text-center"><img class="dla-kogo-img"
                                                                  src="@/assets/poliglotiki/images/bird-1.png"></div>
                                </div>
                            </div>

                            <div class="col-lg-5 col-12" v-if="timetable && timetables && !profileMode && !loading">
                                <v-select :label="$t('timetable')" :options="timetables" v-model="timetable"
                                          :placeholder="$t('select_timetable_')"
                                          class="timetable-selector">
                                    <template #selected-option="{ description }">
                                        {{ description }}
                                    </template>
                                    <template #option="{ description }">
                                        {{ description }}
                                    </template>
                                </v-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <TimetableNotice/>
                            </div>
                        </div>
                        <div class="row mt-1 mb-4 justify-content-center" v-if="langsShortcuts">
                          <div class="col-lg-4 col-12 ind-lang-selector" v-for="item in langsShortcuts" :key="item.lang">
                              <span :class="{'is-active': lang === item.lang }" @click="applyFilterTimetables('lang/' + item.lang, null)">
                                {{ item.name }}
                              </span>
                          </div>
                        </div>
                        <div class="row mt-3 mb-3" v-if="timetable && timetable.description2 && !loading">
                            <div class="col-lg-12">
                                {{timetable.description2}}
                            </div>
                        </div>
                        <div class="row" v-if="!profileMode && !loading">
                            <!--<div class="col-12">
                                <span class="strong-red">{{ $t('unlimited_lessons_count') }}</span>
                            </div>
                            <div class="col-12">
                                <span class="strong-red">{{ $t('free_3_days_lessons') }} <span v-if="timetable">{{ $t('free_3_days_lessons_notice') }}</span></span>
                            </div>-->
                        </div>
                        <div class="row" v-if="!profileMode && timetable && !loading">
                            <div class="col-12 mb-lg-0 mb-4 mt-3">
                                <span class="strong-black">{{ $t('for_subscribe_select_subscription') }} "<span
                                        class="toSubscriptions" @click="toSubscriptions">{{ $t('sign_up') }}</span>".</span>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="!timetable && !loading">
                            <div class="col-lg-12">
                                <p>{{ $t('ot_desc_1') }}</p>
                                <p>{{ $t('ot_desc_2') }}</p>

                                <p><span class="strong-black">{{ $t('if_your_want_subscribe_') }}
                                    <span class="strong-red">{{ $t('individualNBSPlessons') }}</span>, {{ $t('_go_to_link_') }}
                                    <router-link to="/individual">{{ $t('_link_') }}</router-link>.</span>
                                </p>
                            </div>
                        </div>
                        <div class="row" v-if="!timetable">
                            <div class="col-12 order-lg-1 order-5 text-left">
                                <div v-for="item in timetables" :key="item.id" class="row mb-lg-5 active-timetables">
                                    <div class="col-12">
                                        <TimetableItemOT :timetable="item"
                                                         :subscriptions="getWithoutOneTime(item)"
                                                         @order="order"
                                                         @more="more"
                                                         @bonusCourseClick="bonusCourseClick"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 order-lg-1 order-5" ref="subscriptionsList">
                                <SubscriptionsList v-if="timetable && !profileMode && timetable.subscriptions"
                                                   :subscriptions="timetable.subscriptions"
                                                   @order="orderSubscription"
                                                   @bonusCourseClick="bonusCourseClick"
                                />
                                <SubscriptionsList v-if="timetable && !profileMode && !timetable.subscriptions"
                                                   :subscriptions="subscriptions"
                                                   @order="orderSubscription"
                                                   @bonusCourseClick="bonusCourseClick"
                                />
                            </div>
                            <!--<div class="col-12 order-lg-2 order-2 mt-4" v-if="!timetable && timetables && !profileMode">
                                <v-select label="Расписание" :options="timetables" v-model="timetable"
                                          placeholder="Выберите группу, чтобы посмотреть расписание занятий и записаться"
                                          class="timetable-selector">
                                    <template #selected-option="{ description }">
                                        {{ description }}
                                    </template>
                                    <template #option="{ description }">
                                        {{ description }}
                                    </template>
                                </v-select>
                            </div> -->

                            <div class="col-12 order-lg-4 order-4">
                                <full-calendar v-if="timetable"
                                               ref="fullCalendar"
                                               height="auto"
                                               class="demo-app-calendar"
                                               lang="ru"
                                               scheduler-license-key="GPL-My-Project-Is-Open-Source"
                                               :plugins="calendarPlugins"
                                               :weekends="calendarWeekends"
                                               :event-time-format="eventTimeFormat"
                                               :min-time="businessHours.startTime"
                                               :max-time="businessHours.endTime"
                                               :header="{
                                        left: 'prev,today,next',
                                        center: 'title',
                                        right: 'dayGridMonth timeGridWeek timeGridDay'
                                      }"
                                               :locale="locale"
                                               :events="timetablesEvents"
                                               :eventRender="eventRender"
                                               :eventDataTransform="eventDataTransform"
                                               @eventClick="eventClick"
                                               @dateClick="dateClick"
                                />

                                <modal
                                        :show="assignDialog"
                                        @close="assignDialog = false"
                                >
                                    <template v-slot:header v-if="timetable">
                                        <h2>{{ $t('do_you_want_subscribe_') }} {{ timetable.description }}?</h2>
                                    </template>
                                    <p>{{ $t('subscribe_notifications_notice') }}</p>
                                    <template v-slot:footer>
                                        <base-button type="secondary" @click="assignDialog = false" :disabled="loading">
                                            {{ $t('cancel') }}
                                        </base-button>
                                        <base-button
                                                type="primary" @click="submitAssign" :disabled="loading">
                                            {{ $t('sign_up') }}
                                        </base-button>
                                    </template>
                                </modal>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="container">
                <OnlineTeacherComments/>
            </div><!-- /.container -->
        </div>

        <div v-if="popup" :style="popupStyle" class="popup popup-shadow">
            <div class="align-content-end" align="right">
                <button type="button"
                        class="close"
                        @click="popup=false"
                        data-dismiss="modal"
                        aria-label="Close">
                    <span>×</span>
                </button>
            </div>
            <div class="popup-header">
                <img class="popup-image" v-if="selectedCourse.logo"
                     :src="`https://www.poliglotiki.ru${selectedCourse.logo}`">
                <div class="popup-title">{{ selectedCourse.name }}</div>
            </div>
            <div class="popup-description"> {{ selectedCourse.description }}</div>
            <div class="popup-link" v-if="selectedCourse.url">
                <a :href="`https://www.poliglotiki.ru${selectedCourse.url}`" target="_blank">{{ $t('more_about_course') }}</a>
            </div>

            <div v-if="selectedTeacher" class="pt-5">
                <div class="popup-header">
                    Занятие ведет:
                    <img class="popup-image" v-if="selectedTeacher.photo"
                         :src="`https://www.poliglotiki.ru/images/teachers/${selectedTeacher.photo}`">
                    <div class="popup-title">{{ selectedTeacher.name }}</div>
                </div>
                <div class="popup-description"> {{ selectedTeacher.description }}</div>
                <div class="popup-link" v-if="selectedTeacher.link">
                    <a :href="selectedTeacher.link" target="_blank">{{ $t('more_about_teacher') }}</a>
                </div>
            </div>

        </div>
    </div>
</template>
<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import ruLocale from '@fullcalendar/core/locales/ru'

import moment from 'moment';
import timetableApi from "../data/TimetablesApi";
import SubscriptionsList from "./Subscriptions/SubscriptionsList";
import subscriptionApi from "../data/SubscriptionApi";
import {isAuthenticated} from "../data/jwt.service";
import userApi from "../data/UserApi";
import TimetableItemOT from "./TimetableItemOT";
import TimetableNotice from "./profile/timetable/TimetableNotice";
import OnlineTeacherComments from "./CourseComponents/OnlineTeacherComments";

export default {
  props: {
    id: {
      type: [Number, String],
    },
    profileMode: {
      type: Boolean,
      default: false,
    },
    lang: {
      type: [String],
    },
    minAge: {
      type: [Number, String],
    },
    maxAge: {
      type: [Number, String],
    },
  },
  components: {
    OnlineTeacherComments,
    SubscriptionsList,
    FullCalendar, // make the <FullCalendar> tag available
    TimetableItemOT,
    TimetableNotice,
  },
  name: 'timetables',

  data: function () {
    const that = this
    return {
      eventRender: (info) => {
        if (this.isMskTimezone) return
        info.el.querySelector('.fc-title').innerHTML =
            "<span class='fc-msk-time' title='" + this.$t('moscow_time_notice') + "'>("
            + info.event.extendedProps.startTime + "\u00A0МСК)</span> " + info.el.querySelector('.fc-title').innerHTML;
      },

      timetablesEvents: function (fetchInfo, successCallback, failureCallback) {
        that.popup = false
        let start = moment(fetchInfo.startStr).format('YYYY-MM-DD')
        let end = moment(fetchInfo.endStr).format('YYYY-MM-DD')
        if (that.timetable) {
          timetableApi.fetchTimetableByDates(start, end, that.timetable.id, that.id)
              .then(response => {
                successCallback(response)
              })
              .catch(error => {
                failureCallback(error)
              })
        } /*else {
                        timetableApi.fetchTimetablesByDates(start, end)
                            .then(response => {
                                successCallback(response)
                            })
                            .catch(error => {
                                failureCallback(error)
                            })
                    }*/
      },
      eventDataTransform: (event) => {
        if (this.isMskTimezone) return event
        event.start = moment(event.start).format('YYYY-MM-DDTHH:mm:ss.000+0300')
        event.end = moment(event.end).format('YYYY-MM-DDTHH:mm:ss.000+0300')
        return event
      },
      businessHours: {
        daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
        startTime: '08:00',
        endTime: '23:00',
      },
      title: null,

      locale: ruLocale,
      calendarWeekends: true,
      calendarEvents: [ // initial event data
        {title: 'Event Now', start: new Date()},
      ],
      calendarPlugins: [ // plugins must be defined in the JS
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
      ],
      titleFormat: { // will produce something like "Tuesday, September 18, 2018"
        month: 'long',
        year: 'numeric',
        day: '2-digit',
        weekday: 'long',
      },
      eventTimeFormat: { // like '14:30:00'
        hour: 'numeric',
        minute: '2-digit',
        hour12: false,
        omitZeroMinute: false,
      },
      assignDialog: false,
      selectedEvent: null,
      selectedCourse: null,
      selectedTeacher: null,

      timetables: [],
      timetable: null,
      timetableId: null,

      error: null,
      fieldsErrors: [],
      childFieldsErrors: [],
      loading: false,

      popup: false,
      popupStyle: {top: 0, left: 0},

      langFilter: null,
      ageFilter: null,

      ageId: null,
      langId: null,

      ages: [
        {id: 1, min: 1, max: 3},
        {id: 2, min: 4, max: 8},
        {id: 3, min: 9, max: 12},
        {id: 4, min: 12, max: 17},
      ],

      langs: [
        {id: 1, min: 1, max: 3},
        {id: 2, min: 4, max: 8},
        {id: 3, min: 9, max: 12},
        {id: 4, min: 12, max: 17},
      ],

      langsShortcuts: [
        { lang: 'en', name: 'Английский язык'},
        { lang: 'es', name: 'Испанский язык'}
      ],

      subscriptions: [],

      isMskTimezone: true,

      oneOffSubscriptionIds: [],
      oneOffSubscriptionTimetablesIds: [],
    }
  },

  computed: {
    pageTitle() {
      if (this.timetable) return "Расписание занятий " + this.timetable.description

      if (this.lang && this.minAge && this.maxAge) {
        return "OnlineTeacher - безлимитные групповые занятия на " + this.getLangTitle(this.lang) + " языке для детей " + this.minAge + "-" + this.maxAge + "\u00A0лет"
      } else if (!this.lang && this.minAge && this.maxAge) {
        return "OnlineTeacher - безлимитные групповые занятия для детей " + this.minAge + "-" + this.maxAge + "\u00A0лет"
      } else if (this.lang && !this.minAge && !this.maxAge) {
        return "OnlineTeacher - безлимитные групповые занятия на " + this.getLangTitle(this.lang) + " языке для детей"
      }

      return "OnlineTeacher - безлимитные групповые занятия по расписанию"
    },

    pageHeaderHtml() {
      if (this.timetable) return "Расписание занятий " + this.timetable.description

      if (this.lang && this.minAge && this.maxAge) {
        return "OnlineTeacher - <span class='strong-green'>безлимитные</span> групповые занятия на " + this.getLangTitle(this.lang) + " языке для детей " + this.minAge + "-" + this.maxAge + "\u00A0лет"
      } else if (!this.lang && this.minAge && this.maxAge) {
        return "OnlineTeacher - <span class='strong-green'>безлимитные</span> групповые занятия для детей " + this.minAge + "-" + this.maxAge + "\u00A0лет"
      } else if (this.lang && !this.minAge && !this.maxAge) {
        return "OnlineTeacher - <span class='strong-green'>безлимитные</span> групповые занятия на " + this.getLangTitle(this.lang) + " языке для детей"
      }

      return "OnlineTeacher - <span class='strong-green'>безлимитные</span> групповые занятия по расписанию"
    }
  },

  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: '☝☝☝☝☝ Наша уникальная платформа позволяет детям в возрасте от 1 года до 12 лет заниматься online из любой точки мира в удобное время.'
        }
      ]
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.isMskTimezone = userApi.isMskTimezone()

    if (this.lang) this.langFilter = 'lang/' + this.lang
    if (this.minAge && this.maxAge) this.ageFilter = 'min/' + this.minAge + '/max/' + this.maxAge

    this.loading = true

    timetableApi.fetchTimetables()
        .then(response => {
          this.timetables = this.filterByProps(response)
          this.loading = false
        })
        .catch(error => {
          let data = error.response.data
          this.error = this.pretty(data)
          this.loading = false
        })

    if (this.id) {
      timetableApi.fetchTimetable(this.id)
          .then(response => {
            this.timetable = response
            this.loading = false
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    }

    if (isAuthenticated()) {
      userApi.fetchProfile()
          .then(response => {
            //Исключаем одноразовые промо подписки
            this.oneOffSubscriptionIds = response.oneOffSubscriptionIds
            this.oneOffSubscriptionTimetablesIds = response.oneOffSubscriptionTimetablesIds
            subscriptionApi.fetchGroupSubscriptions()
                .then(response => {
                  this.subscriptions = response //.filter(s => ids.indexOf('' + s.idsubscription) === -1)
                })
                .catch(error => {
                  let data = error.response.data
                  this.error = this.pretty(data)
                  this.loading = false
                })
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    } else {
      subscriptionApi.fetchGroupSubscriptions()
          .then(response => {
            this.subscriptions = response
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    }
  },

  watch: {
    timetable: function () {
      if (this.$refs.fullCalendar) {
        this.$refs.fullCalendar.getApi().refetchEvents()
        this.popup = false
      }
    },
  },

  methods: {

    filterByProps(timetables) {
      if (!this.lang && !this.minAge && !this.maxAge) return timetables
      let filtered = []
      for (let timetable of timetables) {
        let ageMatch = this.minAge && this.maxAge
            && ((timetable.min_age >= Number(this.minAge) && timetable.min_age <= Number(this.maxAge))
                || (timetable.max_age >= Number(this.minAge) && timetable.max_age <= Number(this.maxAge)))
        let langMatch = timetable.lang === this.lang

        if (this.lang && this.minAge && this.maxAge) {
          if (langMatch && ageMatch) filtered.push(timetable)
        } else if (!this.lang && this.minAge && this.maxAge) {
          if (ageMatch) filtered.push(timetable)
        } else if (this.lang && !this.minAge && !this.maxAge) {
          if (langMatch) filtered.push(timetable)
        }
      }
      return filtered
    },

    eventClick(info) {
      if (this.timetable) {
        this.selectedEvent = info.event
        this.selectedCourse = this.getCourse(this.selectedEvent.extendedProps.timetableId, this.selectedEvent.extendedProps.timetableScheduleId);
        this.selectedTeacher = this.getTeacher(this.selectedEvent.extendedProps.timetableId, this.selectedEvent.extendedProps.timetableScheduleId);
        this.popupStyle = {top: info.jsEvent.pageY + 'px', left: info.jsEvent.pageX + 'px'}
        this.popup = true
      }
    },

    dateClick(arg) {
      this.popup = false
    },

    submitAssign() {
      if (this.timetable) {
        this.error = null
        this.fieldsErrors = []
        this.loading = true
        timetableApi.assignTimetables(this.timetable.id)
            .then(response => {
              this.loading = false
              this.assignDialog = false
              this.$router.push('/schedule/' + this.timetable.id)
            })
            .catch(error => {
              let data = error.response.data
              this.error = this.pretty(data)
              this.loading = false
              this.assignDialog = false
            })
      }
    },

    timetableChanged() {
      console.log(this.timetable)
    },

    fieldError(fieldName) {
      let errors = []
      if (this.fieldsErrors) {
        this.fieldsErrors.filter(field => {
          if (field.field === fieldName) {
            errors.push(field.message)
          }
        })
      }
      if (errors.length > 0)
        return errors.join(', ')
      return null
    },
    pretty(value) {
      console.log(value)
      if (value.message) {
        return value.message
      }
      return JSON.stringify(value, null, 2)
    },

    getTimetable(timetableId) {
      for (let timetable of this.timetables) {
        if (timetable.id === Number(timetableId)) {
          return timetable
        }
      }
      return null
    },

    getCourse(timetableId, timetableScheduleId) {
      for (let timetable of this.timetables) {
        if (timetable.id === timetableId) {
          if (timetable.schedules && timetable.schedules.length > 0) {
            for (let schedule of timetable.schedules) {
              if (schedule.id === timetableScheduleId) return schedule.course
            }
          }
        }
      }
      return null
    },

    getTeacher(timetableId, timetableScheduleId) {
      for (let timetable of this.timetables) {
        if (timetable.id === timetableId) {
          if (timetable.schedules && timetable.schedules.length > 0) {
            for (let schedule of timetable.schedules) {
              if (schedule.id === timetableScheduleId) return schedule.teacher
            }
          }
        }
      }
      return null
    },

    orderSubscription(subscription) {
      console.log("orderSubscription " + JSON.stringify(subscription))
      //this.assignDialog = true
      this.$router.push('/subscription/order/' + subscription.idsubscription + '/' + this.timetable.id)
    },

    toSubscriptions() {
      this.$refs.subscriptionsList.scrollIntoView();
    },

    order(subscription, timetable) {
      if (subscription.stype === 'OnlineTeacher Group')
        this.$router.push('/subscription/order/' + subscription.idsubscription + '/' + timetable.id)
      else
        this.$router.push('/subscription/order/' + subscription.idsubscription)
    },

    bonusCourseClick(subscription) {
      if (subscription.courses && subscription.courses.length > 0) {
        this.$router.push('/course/' + subscription.courses[0].slug)

      }
    },

    more(timetable) {
      this.$router.push('/schedule/' + timetable.id)
    },

    onBack() {
      alert("back")
    },

    getWithoutOneTime(timetable) {
      if (timetable.subscriptions) {
        if (this.oneOffSubscriptionTimetablesIds.some(el => el == timetable.id)) {
          return timetable.subscriptions.filter(s => this.oneOffSubscriptionIds.indexOf('' + s.idsubscription) === -1)
        }
        return timetable.subscriptions
      } else {
        if (this.oneOffSubscriptionTimetablesIds.some(el => el == timetable.id)) {
          return this.subscriptions.filter(s => this.oneOffSubscriptionIds.indexOf('' + s.idsubscription) === -1).filter(s => s.timetablesCount === 0)
        }
        return this.subscriptions.filter(s => s.timetablesCount === 0)
      }
    },

    applyFilterTimetables(lang, age) {
      this.langFilter = lang
      this.ageFilter = age
      this.filterTimetables();
    },

    filterTimetables() {
      if (this.langFilter && this.ageFilter) {
        this.$router.push('/schedule/' + this.langFilter + '/' + this.ageFilter)
      } else if (this.langFilter && !this.ageFilter) {
        this.$router.push('/schedule/' + this.langFilter)
      } else if (!this.langFilter && this.ageFilter) {
        this.$router.push('/schedule/' + this.ageFilter)
      } else {
        this.$router.push('/schedule')
      }
    },

    getLangTitle(lang) {
      if (lang === 'en') return "английском";
      if (lang === 'de') return "немецком";
      if (lang === 'ch') return "китайском";
      if (lang === 'es') return "испанском";
      if (lang === 'fr') return "французском";
      if (lang === 'ru') return "русском";

      return "";
    }
  }
};
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
<style lang="scss">
    // you must include each plugins' css
    // paths prefixed with ~ signify node_modules
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
    @import '~@fullcalendar/timeline/main.css';
    @import '~@fullcalendar/resource-timeline/main.css';
</style>
<style>
    .fc-msk-time {
        cursor: help;
        color: #231c37;
        font-family: Manrope Bold;
        opacity: 0.5;
        font-size: 11px;
        text-decoration: none;
        display: inline-block;
    }

    .fc-timeGridWeek-view .fc-time-grid-event .fc-content,
    .fc-timeGridWeek-view .fc-time-grid-event .fc-content .fc-title,
    .fc-timeGridWeek-view .fc-time-grid-event .fc-content .fc-time {
        overflow: visible;
        background: inherit;
    }

    .popup-link a {
        background: #bde3b5;
        color: #231c37;
        font-size: 16px;
        font-family: "Manrope Bold";
        text-align: center;
        display: block;
        width: 100%;
        border-radius: 5px;
        padding: 5px 0;
    }

    .popup-description {
        line-height: 18px;
        font-size: 16px;
        color: #4f4d5c;
        clear: both;
        margin: 10px 0;
        text-align: justify;
    }

    .popup-title {
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #231c37;
    }

    .popup-image {
        width: 85px;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .popup-shadow {
        position: absolute;
        box-shadow: 2px 3px 11px 1px rgba(0, 0, 0, 0.2);
        background: white;
        border: 1px solid #d7e0e5;
        z-index: 1;
        border-radius: 6px;
        padding: 14px;
        max-width: 350px;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 15px;
        font-size: 18px;
        color: #231c37;
        font-family: "Manrope Bold";
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }

    .active .red-btn, .red-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }

    .timetable-selector {
        height: 56px;
        font-family: Manrope Bold;
        font-size: 16px;
        color: #231c37;
    }

    .timetable-selector .vs__dropdown-toggle {
        padding: 11px;
    }

    .schedules-header h1 {
        font-family: "Manrope Bold";
        color: #231c37;
        font-size: 28px;
    }

    .schedules-header h1 a {
        color: #231c37;
    }

    .schedules-header h1 a:hover {
        text-decoration: underline;
    }

    .schedules-sub-header h2 {
        font-family: "Manrope Bold";
        color: #231c37;
        font-size: 24px;
    }

    .fc-center h2::first-letter {
        text-transform: uppercase;
    }

    .fc-center h2 {
        font-size: 16px;
        color: #4f4d5c;
        font-family: "Manrope Bold";
    }

    .fc-next-button .fc-icon, .fc-prev-button .fc-icon {
        line-height: 20px;
    }

    .fc-button {
        background-color: white !important;
        box-shadow: inset 3px 2px 6px 0px rgba(168, 168, 168, 0.4);
        color: #4f4d5c !important;
        font-family: "Manrope Bold";
        font-size: 14px;
        border: 1px solid #d7e1e5 !important;
        border-radius: 18px;
        padding: 7px 30px;
    }

    .fc-button:hover {
        color: #000000 !important;
    }

    .fc-button.fc-button-active, .fc-today-button.fc-button:disabled {
        color: #231c37 !important;
        text-shadow: 1px 1px 2px #fcff00;
        border: 1px solid transparent !important;
        background-color: #ffdb00 !important;
    }

    .fc-day-top .fc-day-number {
        display: block;
        text-align: center;
        float: none !important;
        font-size: 14px;
        color: #4f4d5c;
        margin-bottom: 10px;
    }

    .fc-day-header {
        background-color: #f5fbfd;
        color: #231c37;
        font-family: "Manrope Bold";
        text-transform: uppercase;
        font-size: 12px;
        padding-top: 8px !important;
        padding-bottom: 8px !important;
    }

    .timetable-container {
        background-color: white;
    }

    .fc-day-grid-event > .fc-content {
        white-space: normal;
    }

    .fc-event {
        border-radius: 6px;
        cursor: pointer;
    }

    .fc-day-grid-event.fc-event {
        padding-top: 12px;
        padding-bottom: 10px;
        padding-left: 9px;
        padding-right: 9px;
        margin: 5px 10px;
        border: none;
    }

    .fc-time {
        font-family: Manrope Bold;
        color: #231c37;
        font-size: 14px;
    }

    .fc-title {
        color: #4f4d5c;
        font-family: "Manrope Light";
        font-size: 14px;
        text-decoration: none;
    }

    .fc-title:hover {
        text-decoration: underline;
    }

    .fc-sat, .fc-sun {
        background: rgba(255, 0, 32, 0.07);
    }

    .conflict-lesson {
        cursor: pointer;
    }

    .fc-icon {
        line-height: 0.6;
    }

    .fc-center {
        margin: 10px 0;
    }

    .client-pointer {
        cursor: pointer;
    }

    .client-pointer:hover {
        text-decoration: underline;
    }

    .abo-chip {
        height: auto !important;
        margin-bottom: 1px !important;
    }

    .abo-chip-other {
        opacity: 0.5;
    }

    .time-notice {
        color: #ed1c24;
        font-size: 15px;
        font-family: "Manrope Bold";
    }

    .toSubscriptions {
        text-decoration: underline;
        cursor: pointer;
    }

    .knopka input {
        text-align: center;
    }

    .no-timetables {
        text-align: center;
        font-size: 18px;
    }

    .fc-toolbar.fc-header-toolbar .fc-center h2 {
        margin-left: 0.75em;
    }

    .fc-toolbar.fc-header-toolbar .fc-left .fc-button-group {
        min-width: 333px;
        max-width: 100%;
    }

    @media (max-width: 767.98px) {
        .fc-toolbar {
            display: block;
            text-align: center;
        }

        .fc-day-grid-event.fc-event {
            padding: 1px !important;
            margin: 1px !important;
        }

        .fc-title {
            word-break: break-word;
            line-height: 14px;
        }

        .fc-time-grid-event .fc-time {
            word-break: break-word;
            white-space: normal;
        }

        .fc-axis .fc-widget-content {
            width: 50px !important;
        }

        .fc-time-grid .fc-event, .fc-time-grid .fc-bgevent {
            position: inherit;
        }

        .fc-time {
            font-size: 12px;
        }
    }

</style>
